import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import * as commonActions from '../../actions/commonActions';

const SimpleFileInput = ({ name, label, onLoaded }) => {
    function onChangeLocal(e) {
        commonActions.lockScreen();
        const reader = new FileReader();
        const beneficiariFile = e.target.files[0];
        reader.onloadend = () => {
            commonActions.unlockScreen();
            onLoaded(beneficiariFile, reader.result);
        };

        if (!_.isNil(beneficiariFile))
            reader.readAsDataURL(beneficiariFile);
        else
            onLoaded({}, null);
    }

    return (
        <div className='formComponent'>
            <div className="input-group">
                <span className="btn btn-default btn-file">
                    {label}<input type='file' name={name} onChange={onChangeLocal} />
                </span>
            </div>
        </div>
    );
};

SimpleFileInput.propTypes = {
    label: PropTypes.string.isRequired, // Label
    name: PropTypes.string.isRequired,
    onLoaded: PropTypes.func.isRequired, // When the file is fully loaded
};

export default SimpleFileInput;